var _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,9.3c-0.4,0-3.7,0-6.1,0l-3.3,2.9L18,10.4h-1.2C16.8,10.4,14.7,9.3,14,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,8.7L7.9,9.3c2.4,0,5.6,0,6.1,0c0.7,0,2.8,1.1,2.8,1.1h1.2c0,0-2.5-1.8-4.4-1.8C12.4,8.7,8.7,8.7,8.7,8.7 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.9,9.3c-1.5,0-2.6,0-2.7,0C5,9.2,5,8.9,5,8.7c0,0-0.1,0-0.1,0c-0.6,0-0.6,0.6-0.2,1.1 c0.3,0.4,1,0.4,1.8,0.4c0.8,0,2.5-1.5,2.5-1.5c-0.1,0-0.1,0-0.1,0L7.9,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2,9.2c0.1,0,1.3,0,2.7,0l0.7-0.7c-0.6,0-2.9,0-3.7,0C5,8.9,5,9.2,5.2,9.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5,11.4l1-1.3c0,0,13.4,0.3,14.6,0.3s2.4,0.4,2.4,0.4L5,11.4z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2,15.7c-3.6,0-15.2,0-15.2,0s0.9-2.2,1.2-2.8C2.6,12,3,11.2,4.4,11.2c5.7,0,18.6-0.4,18.6-0.4 S20.4,15.7,16.2,15.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 20.1,
    cy: 11.8,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.4,11.8c0,0.2-0.1,0.4-0.3,0.4s-0.3-0.2-0.3-0.4c0-0.2,0.1-0.4,0.3-0.4S18.4,11.6,18.4,11.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 17.1,
    cy: 11.8,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 16,
    cy: 11.8,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 13.5,
    cy: 11.8,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000"
    },
    cx: 6.5,
    cy: 11.8,
    rx: 0.3,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 14.9,
    style: {
      fill: "#000"
    },
    width: 3.7,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M5.9,14.1l0.4,0.7c0,0.1,0.1,0.1,0.2,0.1h2.2c0.1,0,0.1,0,0.2-0.1l0.8-0.7c0.2-0.1,0.1-0.5-0.1-0.5H6 C5.9,13.7,5.8,13.9,5.9,14.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "6.4,10.1 8.6,10.2 9.3,9.3 7.6,9.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "9,8.3 7.6,9.3 9.3,9.3 10.2,8.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.ee04457ddbd3e7f131f7b85b9e42c44a.svg";
export { ForwardRef as ReactComponent };